module.exports = __webpack_public_path__ + "img/900043147.5daffd90.png";